/* eslint-disable  */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useContext, useEffect, useState, useRef } from 'react';
import { dofStyles } from '../JSStyles/dofStyles';
import DOFHeader from './Header';
import { useParams } from 'react-router-dom';
import {
  Grid,
  Typography,
  RACModalCard,
  RACButton,
  RACTextbox,
  RACRadio,
  Paper,
  Box,
  RACSelect,
} from '@rentacenter/racstrap';
import { ResidenceContext } from '../context/userInformation/ResidenceContextProvider';
import { IdentityContext } from '../context/userInformation/IdentityContextProvider';
import { useHistory } from 'react-router-dom';
import DocumentCapture from '../common/camera/OpenCamera';
import { ReactComponent as UploadIcon } from './../images/uploadImage.svg';
import { ReactComponent as ImageIcon } from './../images/image-icon.svg';
import { ReactComponent as PdfIcon } from './../images/pdf-icon.svg';
import { ReactComponent as DeleteIcon } from './../images/delete-icon.svg';
import MessagePopup from '../common/MessagePopup';
import FileToPDFViewer from '../common/FileToPDFViewer';
import { CreateCustomerStg, UpdateCustomer } from '../api/user';
import ScreenLoader from '../common/loader/ScreenLoader';
import BreadCrumb from './BreadCrumb';
import {
  ACCEPTED_FILE_TYPES,
  SIZE_UNIT_KB,
  SIZE_UNIT_MB,
  SIZE_UNIT_GB,
  RESIDENCE_TAB_DOCUMENT_LIST
} from '../constants/constants';
import { handleFile, uploadDocuments } from '../common/helperFunction/HelperFunction';
import { loadGoogleMapsScript } from '../common/GoogleAddressLoad';
import { useTranslation } from 'react-i18next';
import { IncomeContext } from '../context/userInformation/IncomeContextProvider';



const ResidenceTab: React.FC = () => {
  const { t } = useTranslation();
  const dofAuthSessionValue: any = window.sessionStorage.getItem("dofAuthValues");
  const sessionStorageValues: any = JSON.parse(dofAuthSessionValue);
  const {
    residenceInformation,
    setResidenceInformation,
    setResidenceDoc,
    setFileSize,
    setFileType,
    fileType,
    fileSize,
    showResidenceVerfDocument,
    setShowResidenceVerfDocument,
    residenceDoc,
    residenceRadioOption,
    residenceTenureTypeOption,
    stateOption,
    setStgCustomerAddressId,
    stgCustomerAddressId,
    stateDetails,
    residenceSave,
    setResidenceSave
  } = useContext(ResidenceContext) || {};
  const { consentDate } = useContext(IncomeContext) || {};
  const context = useContext(IdentityContext);
  if (!context) {
    return <div> {t("Application is not available")}</div>;
  }

  const { identityInformation, stgCustomerProfileId, stgCustomerIdentityId, otpSave, getCustomerRes, getStgCustomerRes, secretValues } = context

  const [openPdf, setOpenPdf] = useState<boolean>(false);
  const [base64Files, setBase64Files] = useState<string[]>([]);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [errorMessages, setErrorMessages] = useState<{ [key: string]: string }>({});
  const [messagePopup, setMessagePopup] = useState<boolean>(false);
  const [isNextEnabled, setIsNextEnabled] = useState<boolean>(false);
  const [showMoreDocuments, setShowMoreDocuments] = useState<boolean>(false);
  const [intialProof, setIntialProof] = useState<number>(3);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [googleMapsReady, setGoogleMapsReady] = useState(false);
  const [screeenLoader, setScreeenLoader] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('')
  const classes = dofStyles();
  const history = useHistory();
  const featureFlagDetailsString: any = window.sessionStorage.getItem("featureFlagDetails");
  const featureFlagDetail: any[] = featureFlagDetailsString ? JSON.parse(featureFlagDetailsString) : [];
  const canEnableCountryCode = featureFlagDetail.find((param: { paramKeyName: string; }) =>
    param.paramKeyName === 'CountryCode');
  const steps = [
    { label: 'Identity', isActive: true, isCompleted: true },
    { label: 'Code Confirmation', isActive: true, isCompleted: true },
    { label: 'Residence', isActive: true, isCompleted: false },
    { label: 'Income', isActive: false, isCompleted: false },
  ];
  const [deepCloneResidenceInformation, setDeepCloneResidenceInformation] = useState<any>(JSON.parse(JSON.stringify(residenceInformation)));
const NAME_REPLACEABLE_REGEX: RegExp = /[^A-Za-z0-9À-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü'.,' -]+$/gi;

  interface RouteParams {
    customerId: string;
    tcid: string;
  }

  // fetching the path params value
  const { customerId, tcid } = useParams<RouteParams>();

  useEffect(() => {
    if (!residenceDoc) {
      setShowResidenceVerfDocument?.(false);
    } else if (residenceDoc) {
      setShowResidenceVerfDocument?.(true);
    }
    // when the value is prefetched
  }, [residenceDoc, setShowResidenceVerfDocument]);

  useEffect(() => {
    console.log('testtttt', residenceRadioOption);
    if (residenceRadioOption) {
      setResidenceInformation?.((prev) => ({
        ...prev,
        typeOfResidence: "RENT",
      }));
    }
  }, [residenceRadioOption, setResidenceInformation]);

  // Check if all mandatory fields are filled
  useEffect(() => {
    const allFieldsFilled =
      !!residenceInformation?.street &&
      !!residenceInformation?.exteriorNumber &&
      !!residenceInformation?.suburb &&
      !!residenceInformation?.postalCode &&
      !!residenceInformation?.city &&
      !!residenceInformation?.state &&
      !!residenceInformation?.timeOccupyingCurrentResidence &&
      !!residenceInformation?.typeOfResidence;

    setIsNextEnabled(allFieldsFilled);
  }, [residenceInformation]);

  useEffect(() => {
    const loadScript = async () => {
      try {
        await loadGoogleMapsScript(secretValues);
        console.log("Google Maps script loaded");
        setGoogleMapsReady(true);
      } catch (err) {
        console.log("Failed to load Google Maps", err);
      }
    };

    loadScript();
  }, []);

  useEffect(() => {
    if (!googleMapsReady) return;
    if (!inputRef.current || !window.google?.maps) {
      console.log("inputRef or google maps not ready");
      return;
    }
    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ['address'],
      componentRestrictions: { country: 'mx' },
      languageCode: 'es'
    });

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      console.log("Selected place", place);

      const parsed = parseAddressComponents(place.address_components);
      console.log("Parsed Address:", parsed);
      console.log("MX States", stateDetails?.filter((item) => item.countryCode === 'MX'));

      const stateAbbreviation = stateDetails?.find(
        (item) => parsed.state === item.stateProvinceName && item.countryCode === 'MX'
      );

      const updatedResidenceInfo = {
        ...residenceInformation,
        street: parsed.street_name,
        exteriorNumber: parsed.street_number,
        suburb: parsed.colonia,
        city: parsed.city,
        postalCode: parsed.postal_code,
        state: stateAbbreviation?.abbreviation || ''
      };

      setResidenceInformation?.(updatedResidenceInfo);
    });

    return () => {
      // optional: cleanup listener
    };
  }, [googleMapsReady, residenceInformation, stateDetails]);


  console.log('address', residenceInformation);

  function parseAddressComponents(components: any) {
    const get = (type: any) =>
      components.find((comp: any) => comp.types.includes(type))?.long_name || "";

    return {
      street: `${get("route")} ${get("street_number")}`.trim(), // e.g. Reforma 123
      street_name: get("route"),                                // Reforma
      street_number: get("street_number"),                      // 123
      colonia: get("sublocality") || get("neighborhood"),       // Juárez
      city: get("locality") || get("administrative_area_level_2"),
      state: get("administrative_area_level_1"),
      postal_code: get("postal_code"),
      country: get("country"),
    };
  }

  // Handle input changes for text fields
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName?: string) => {
  const { name, value } = e.target;
  const key = fieldName ? fieldName : name;
  

  if (['street', 'exteriorNumber', 'interiorNumber', 'suburb', 'city'].includes(key)) {
    if (NAME_REPLACEABLE_REGEX.test(value)) {
      return; 
    }
  }

  

  if (setResidenceInformation) {
    setResidenceInformation((prevState) => ({
      ...prevState,
      [key]: value.trimStart(),
    }));
  }
  setErrorMessages((prev) => ({ ...prev, [key]: '' }));
};

  const renderResidenceOptions = () => (
    <>
      {residenceRadioOption?.map((option) => (
        <RACRadio
          key={option.value}
          value={option.value}
          label={option.label}
          name="typeOfResidence"
          checked={residenceInformation?.typeOfResidence === option.value}
          onChange={(event: any) => { handleInputChange(event, "typeOfResidence") }}
        />
      ))}
    </>
  );

  console.log('The state details', stateDetails)
  const ResidenceNextClick = async () => {
    setScreeenLoader(true);

    console.log('Identity Deep clone ', JSON.stringify(deepCloneResidenceInformation));
    const hasChanges = JSON.stringify(residenceInformation) !== JSON.stringify(deepCloneResidenceInformation);
    if (!hasChanges && residenceSave) {
      setScreeenLoader(false);
      history.push('/income');
      return;
    }
    // Prepare data payload
    const stgCustomerPayload = {
      stgCustomerProfileId: Number(stgCustomerProfileId) ? stgCustomerProfileId : undefined,
      action: Number(stgCustomerProfileId) ? "UPD" : "CRT",
      firstName: identityInformation.firstName || '',
      middleInitial: identityInformation.secondName || '',
      lastName: identityInformation.paternalLastName || '',
      maternalLastName: identityInformation.maternalLastName || '',
      gender: identityInformation?.gender ? identityInformation?.gender.toUpperCase() : '',
      dob: identityInformation.dateOfBirth || '',
      maritalStatus: identityInformation.maritalStatus || '',
      phoneNumber: identityInformation.phoneNumber ? identityInformation.phoneNumber.replace(/\D/g, '') : '',
      countryCode: canEnableCountryCode?.paramValue == '1' ? identityInformation.countryCode : undefined,
      emailId: identityInformation.emailId || '',
      referralSources: identityInformation.racPromotions || '',
      phoneType: 'CELL',
      callTime: 'MORN',
      submittedDate: new Date().toISOString().split('T')[0],
      storeNumber: window.sessionStorage.getItem('storeNumber'),
      productCode: sessionStorageValues?.productCode || getStgCustomerRes?.productCode || undefined,
      customerCreatedSource: sessionStorageValues?.clientId || getStgCustomerRes?.customerSource || undefined,
      customerId: sessionStorageValues?.type == 'EC' ? sessionStorageValues?.identifier : undefined,
      consentDate: getStgCustomerRes?.consentDate ?? consentDate ?? null,

      addressInfo: {
        ...(Number(stgCustomerAddressId) && { stgCustomerAddressId: stgCustomerAddressId }),
        residenceType: residenceInformation?.typeOfResidence || '',
        addressLine1: residenceInformation?.street || '',
        addressLine2: residenceInformation?.suburb || '',
        exteriorNumber: residenceInformation?.exteriorNumber || '',
        interiorNumber: residenceInformation?.interiorNumber || '',
        city: residenceInformation?.city || '',
        stateCode: residenceInformation?.state || '',
        postalCode: residenceInformation?.postalCode || '',
        residenceTenureType: residenceInformation?.timeOccupyingCurrentResidence || '',
        residenceVerificationStatus: getStgCustomerRes?.addressInfo?.residenceVerification == "APPROVED" && Number(stgCustomerAddressId) ? 'APPROVED' : 'PENDING'
      }
    };
    // Update Customer Payload

    let updateCustomerPayload: any = ''
    sessionStorageValues?.type == 'EC' ?


      updateCustomerPayload = {
        addresses: [{
          addressId: (getCustomerRes?.addresses && getCustomerRes?.addresses?.length > 0) 
          ? getCustomerRes?.addresses?.[0].addressId 
          : '',
          addressLine1: residenceInformation?.street || '',
          addressLine2: residenceInformation?.suburb || '',
          exteriorNumber: residenceInformation?.exteriorNumber || '',
          interiorNumber: residenceInformation?.interiorNumber || '',
          city: residenceInformation?.city || '',
          state: residenceInformation?.state || '',
          postalCode: residenceInformation?.postalCode || '',
          addressType: (getCustomerRes?.addresses && getCustomerRes?.addresses?.length > 0) ?getCustomerRes?.addresses[0]?.addressType : 'PRIM',
          active: 'Y'
        }],
        customerId: sessionStorageValues?.identifier || '',
        residenceType: residenceInformation?.typeOfResidence || '',
        residenceTenureType: residenceInformation?.timeOccupyingCurrentResidence || null,
      } : null;
    // Override `residenceType` if needed
    if (sessionStorageValues?.type == 'EC') {
      if (residenceInformation?.typeOfResidence === 'RENT') {
        updateCustomerPayload.residenceType = 'RENT';
      } else if (residenceInformation?.typeOfResidence === 'FAMFRD') {
        updateCustomerPayload.residenceType = 'FAMFRD';
      } else {
        updateCustomerPayload.residenceType = 'OWN';
      }
    }

    console.log("Payload Data:", stgCustomerPayload);

    // Validate fields before proceeding
    if (!validateFields()) {
      setScreeenLoader(false);
      return;
    }

    const stgCusProfId = stgCustomerProfileId;
    debugger
    console.log('residenceDoc ', residenceDoc);
    if (residenceDoc) {
      console.log('Resdoc data', residenceDoc);
      const documentData = await handleFile(residenceDoc);
      console.log('Document data', documentData);

      console.log('stgCusProfId ', stgCusProfId, customerId, tcid);

      if (stgCusProfId) {
        const uploadResult = await uploadDocuments(
          stgCusProfId,
          [{ documentType: 'RESDOC', file: documentData?.base64String }],
          customerId
        );
        if (!uploadResult) {
          setScreeenLoader(false);
          setMessagePopup(true);
          setErrorMessage(t('Document upload failed. Please try again with a smaller file.'));
          return;
        }
      } else {
        console.error('Both customerId and tcid are null or invalid.');
      }
    }
    const isStoreCodeFlow = window.sessionStorage.getItem('authKey')?.length ? false : true;
    console.log('isStoreCodeFlow ', isStoreCodeFlow);
    const accessToken = isStoreCodeFlow ? window.sessionStorage.getItem('storeNumber') : window.sessionStorage.getItem('authKey');
    const response: any = sessionStorageValues?.type !== 'EC' ? await Promise.all([CreateCustomerStg(stgCustomerPayload, isStoreCodeFlow, accessToken)]) : await Promise.all([CreateCustomerStg(stgCustomerPayload, isStoreCodeFlow, accessToken), UpdateCustomer(updateCustomerPayload, isStoreCodeFlow, accessToken)]);
    debugger
    if (response[0]?.status == '200') {
      setResidenceSave?.(true);
      setStgCustomerAddressId?.(response[0]?.data?.stgCustomerAddressId);
      history.push('/income');
    }
    setScreeenLoader(false);

  };

  const validateFields = () => {
    let errors = false;
    const newErrorMessages: { [key: string]: string } = {};

    if (residenceInformation) {
      // Reset error message
      setErrorMessages({});

      // Validate specific fields based on business rules
      if (!/^(\d{5}|\d{4}-\d{4})$/.test(residenceInformation.postalCode || '')) {
        newErrorMessages.postalCode = "Enter a Valid Zip code";
        errors = true;
      }

      if (residenceInformation.street.length > 100) {
        newErrorMessages.street = "Street must be max 100 characters.";
        errors = true;
      }

      if (residenceInformation.exteriorNumber.length > 255) {
        newErrorMessages.exteriorNumber = "Exterior Number must be max 255 characters.";
        errors = true;
      }

      if (residenceInformation.suburb.length > 100) {
        newErrorMessages.suburb = "Neighborhood must be max 100 characters.";
        errors = true;
      }

      if (residenceInformation.city.length > 40) {
        newErrorMessages.city = "City must be max 40 characters.";
        errors = true;
      }

      if (residenceInformation.state.length > 50) {
        newErrorMessages.state = "State must be max 50 characters.";
        errors = true;
      }

      // Update error messages state
      setErrorMessages(newErrorMessages);

      return !errors; // Return true if no errors found
    }

    return false; // Return false if residenceInformation is not available
  };

  const pdfModelContent = () => {
    return <FileToPDFViewer file={residenceDoc} />;
  };

  // Handle file input changes
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      handleFiles(Array.from(files));
    }
  };

  // Handle file drop event
  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    console.log('handleDrop', event.dataTransfer.files);
    handleFiles(Array.from(event.dataTransfer.files));
  };

  const handlePrevious = () => {
    if (otpSave || (getStgCustomerRes?.consentDate &&
      new Date().getTime() <= new Date(getStgCustomerRes.consentDate).getTime() - 3 * 365 * 24 * 60 * 60 * 1000)) {
      history.push('/identity')
      return;
    }
    else {
      history.push('/authentication')
      return;
    }
  }
  // Process selected files
  const handleFiles = async (files: File[]) => {
    const validFiles = files.filter((file) =>
      ACCEPTED_FILE_TYPES.includes(file.type)
    );

    setUploadedFiles((prev) => [...prev, ...validFiles]);

    // Convert each file into a Base64 string
    const base64Promises = validFiles.map((file) => convertToBase64(file));
    const base64Results = await Promise.all(base64Promises);

    // Save Base64 results to state
    setBase64Files((prev) => [...prev, ...base64Results]);

    handleFileDetails(files);
  };

  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject(new Error('Failed to convert file.'));
      reader.readAsDataURL(file);
    });
  };

  const handleFileDetails = (files: any) => {
    const fileSizeInBytes = files[0].size;
    setFileType?.(files[0].type);
    setResidenceDoc?.(files[0]);

    let fileSize: any = fileSizeInBytes;
    let sizeUnit = 'bytes';

    if (fileSizeInBytes >= 1024) {
      fileSize = fileSizeInBytes / 1024;
      sizeUnit = SIZE_UNIT_KB;
    }

    if (fileSize >= 1024) {
      fileSize = fileSize / 1024;
      sizeUnit = SIZE_UNIT_MB;
    }

    if (fileSize >= 1024) {
      fileSize = fileSize / 1024;
      sizeUnit = SIZE_UNIT_GB;
    }

    fileSize = fileSize.toFixed(2);
    setFileSize?.(`${fileSize} ${sizeUnit}`);

    const isAcceptedType = ACCEPTED_FILE_TYPES.includes(files[0].type);
    // const isPdf = files[0].type === 'application/pdf';
    const fileSizeNumber = Number(fileSize);

    if (!isAcceptedType) {
      setMessagePopup(true);
      setErrorMessage(
        'Invalid file format. Please upload a PDF, JPEG, or PNG.'
      );
      setResidenceDoc?.('');
      return;
    }

    if (sizeUnit === SIZE_UNIT_KB) {
      setShowResidenceVerfDocument?.(true);
      return;
    }

    if (sizeUnit === SIZE_UNIT_MB && fileSizeNumber >= 5) {
      setMessagePopup(true);
      setErrorMessage('Please upload a file smaller than 5MB.');
      setResidenceDoc?.('');
      return;
    }

    if (
      (sizeUnit === SIZE_UNIT_MB && fileSizeNumber > 20) ||
      sizeUnit === SIZE_UNIT_GB
    ) {
      setMessagePopup(true);
      setErrorMessage('Please upload a file smaller than 20MB.');
      setResidenceDoc?.('');
      return;
    }

    setShowResidenceVerfDocument?.(true);
  };


  return (
    <>
      {screeenLoader ? <ScreenLoader /> : null}
      <DOFHeader
        identity={true}
        residence={true}
        income={false}
        reference={false}
        activeStep="Step 3: Residence"
      />
      <BreadCrumb steps={steps} />

      {messagePopup ? (
        <MessagePopup
          value={{
            message: errorMessage,
            setFunction: setMessagePopup,
            cleanupFunction: setErrorMessage,
          }}
        />
      ) : null}

      <Grid className={classes.referenceContainer1}>
        <Grid className={classes.referenceSection}>
          <Grid>
            <Typography>
              {t("Type of Residence")} <span style={{ color: 'red' }}>*</span>
            </Typography>
            {renderResidenceOptions()}
          </Grid>
          <Grid>
            <Grid>
              <Typography>{t("Proof of Address")}</Typography>
            </Grid>
            <Grid>
              <Typography>
                {t("Accepted Proof of Residence Documents, Listed Below (Choose One)")}:
              </Typography>
            </Grid>
            <Grid>
              <ul style={{ marginTop: '0px' }}>
                {RESIDENCE_TAB_DOCUMENT_LIST.slice(0, intialProof).map((el) => {
                  return (
                    <li key={el.type}>
                      {t(el.value)}
                    </li>
                  );
                })}
              </ul>
            </Grid>
            {/* <Grid>
              <Typography
                style={{ color: '#0F99D6', cursor: 'pointer' }}
                onClick={() => {
                  setShowMoreDocuments(!showMoreDocuments);
                  intialProof === 3 ? setIntialProof(RESIDENCE_TAB_DOCUMENT_LIST.length) : setIntialProof(3)
                }}
              >
                {showMoreDocuments ?
                  t(`Hide Document`) :
                  t('View More Document Examples')
                }
              </Typography>
            </Grid> */}
          </Grid>
          <Grid>
            <Grid>
              <Typography>{t("Choose any method below")}</Typography>
            </Grid>
            <Grid>
              <DocumentCapture
                setResidenceDoc={setResidenceDoc}
                setFileSize={setFileSize}
                setFileType={setFileType}
              />
            </Grid>
            <Grid>{renderFileUploadSection()}</Grid>
          </Grid>
          {showResidenceVerfDocument && renderUploadedDocument()}
          {/* Address Input Fields */}
          {renderAddressInputFields()}
          {/* Note Section */}
          <Grid style={{ marginTop: '20px' }}>
            <Typography>
              <strong>{t("NOTE: ")}</strong>{t("If you prefer to continue with a store coworker, please call or visit your store.")}

            </Typography>
          </Grid>

          {renderNavigationButtons()}
        </Grid>
      </Grid>
    </>
  );

  function renderFileUploadSection() {
    return (
      <Paper
        className={`${classes.drapNDropStyling} ${classes.w91p} ${classes.mb20px}`}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <UploadIcon className={`${classes.mt20px} ${classes.mb15px}`} />
        </Box>
        <label>
          <input
            type="file"
            accept=".png,.jpeg,.jpg,.pdf"
            multiple
            onChange={(e) => {
              handleFileChange(e);
              e.target.value = null;
            }}
            style={{ display: 'none' }}
          />
          <Typography
            variant="body2"
            component="span"
            color="primary"
            className={`${classes.underline} ${classes.cursorPointer} ${classes.primaryFontColor} ${classes.font16px}`}
          >
            {t("Choose a file or drag it here")}
          </Typography>
        </label>
        <Typography
          variant="body2"
          className={`${classes.mt10px} ${classes.lightGreyColor} ${classes.font14px} ${classes.p10px}`}
        >
          {t("JPEG, PNG, PDF up to 5MB")}
        </Typography>
      </Paper>
    );
  }

  function renderUploadedDocument() {
    return (
      <Grid
        style={{
          width: '100%',
          textAlign: 'left',
          padding: '10px',
          display: 'flex',
          paddingTop: '0px',
          cursor: 'pointer',
        }}
      >
        {fileType &&
          (fileType === 'image/png' || fileType === 'image/jpeg') && (
            <ImageIcon style={{ width: '20px', height: '20px' }} />
          )}
        {fileType && fileType === 'application/pdf' && (
          <PdfIcon style={{ width: '20px', height: '20px' }} />
        )}
        <Typography
          className={`${classes.primaryFontColor} ${classes.pl10px}`}
          onClick={() => {
            setOpenPdf(true);
          }}
        >
          {t("Proof of Residence")}{' '}
          <span className={`${classes.fileSizeColor}`}>{fileSize}</span>
        </Typography>
        <DeleteIcon
          style={{
            width: '15px',
            height: '15px',
            marginLeft: '10px',
            marginTop: '3px',
          }}
          onClick={() => {
            setShowResidenceVerfDocument?.(false);
            setResidenceDoc?.('');
          }}
        />
        <RACModalCard
          borderRadius="15px"
          closeIcon={true}
          isOpen={openPdf}
          maxWidth={'sm'}
          className={`${classes.customModal}`}
          title={t(`Proof of Residence`)}
          onClose={() => setOpenPdf(false)}
        >
          {pdfModelContent()}
        </RACModalCard>
      </Grid>
    );
  }

  function renderAddressInputFields() {
    return (
      <>
        {/* Address Input Fields */}
        <Grid container spacing={3} style={{ marginTop: '20px' }} md={12}>
          {/* Street */}
          {/* <Grid md={4} item sm={12} xs={12}>
            <RACTextbox
              inputlabel={"Street"}
              value={residenceInformation?.street || ''}
              name="street"
              required={true}
              OnChange={handleInputChange}
              errorMessage={errorMessages.street}
            />

          </Grid> */}
          <Grid md={4} item sm={12} xs={12} >
            <Typography>{t("Street")}{" "}<span style={{ color: 'red' }}>*</span></Typography>
            {/* <label htmlFor='Street'>{t("Street")}{" "}<span style={{ color: 'red' }}>*</span></label> */}
            <input ref={inputRef} type="text" value={residenceInformation?.street || ''} onChange={handleInputChange} id="Street" placeholder="" style={{ height: '2.25em', width: '100%', borderRadius: '5px', border: '0.0625rem solid #c4c4c4' }} name='street' maxLength={100} />
          </Grid>
          {/* Exterior Number */}
          <Grid md={4} item sm={12} xs={12}>
            <RACTextbox
              inputlabel={t("Exterior Number")}
              value={residenceInformation?.exteriorNumber || ''}
              name="exteriorNumber"
              required={true}
              OnChange={handleInputChange}
              errorMessage={t(errorMessages.exteriorNumber)}
              maxlength={255}
            />
          </Grid>

          {/* Interior Number */}
          <Grid md={4} item sm={12} xs={12}>
            <RACTextbox
              inputlabel={t("Interior Number")}
              value={residenceInformation?.interiorNumber || ''}
              name="interiorNumber"
              required={false}
              OnChange={handleInputChange}
              errorMessage={t(errorMessages.interiorNumber)}
              maxlength={255}
            />
          </Grid>
        </Grid>

        {/* Additional Address Fields */}
        <Grid container spacing={3} style={{ marginTop: '20px' }} md={12}>
          {/* Neighborhood */}
          <Grid md={4} item sm={12} xs={12}>
            <RACTextbox
              inputlabel={t("Suburb")}
              value={residenceInformation?.suburb || ''}
              name="suburb"
              required={true}
              OnChange={handleInputChange}
              errorMessage={t(errorMessages.suburb)}
              maxlength={100}
            />
          </Grid>

          {/* Postal Code */}
          <Grid md={4} item sm={12} xs={12}>
            <RACTextbox
              inputlabel={t("Zip Code")}
              value={residenceInformation?.postalCode || ''}
              name="postalCode"
              required={true}
              OnChange={handleInputChange}
              errorMessage={t(errorMessages.postalCode)}
              maxlength={5}
              type='text'
            />
          </Grid>

          {/* City */}
          <Grid md={4} item sm={12} xs={12}>
            <RACTextbox
              inputlabel={t("City")}
              value={residenceInformation?.city || ''}
              name="city"
              required={true}
              OnChange={handleInputChange}
              errorMessage={t(errorMessages.city)}
              maxlength={40}
            />
          </Grid>
        </Grid>

        {/* State and Date Picker */}
        <Grid container spacing={3} style={{ marginTop: '20px' }} md={12}>
          {/* State */}
          <Grid md={4} item sm={12} xs={12}>
            <RACSelect
              required={true}
              inputLabel={t("State")}
              options={stateOption}
              name="state"
              defaultValue={residenceInformation?.state}
              onChange={(event: any) => { handleInputChange(event, 'state') }}
            />
            {errorMessages.state && (
              <Typography variant="body2" color="error">
                {t(errorMessages.state)}
              </Typography>
            )}
          </Grid>

          {/* Time Occupying Current Residence */}
          <Grid md={4} item sm={12} xs={12}>
            <RACSelect
              required={true}
              inputLabel={t("Time Occupying Current Residence")}
              options={residenceTenureTypeOption}
              name="timeOccupyingCurrentResidence"
              defaultValue={residenceInformation?.timeOccupyingCurrentResidence}
              onChange={(event: any) => { handleInputChange(event, 'timeOccupyingCurrentResidence') }}
            />
            {errorMessages.timeOccupyingCurrentResidence && (
              <Typography variant="body2" color="error">
                {t(errorMessages.timeOccupyingCurrentResidence)}
              </Typography>
            )}
          </Grid>
        </Grid>
      </>
    );
  }

  function renderNavigationButtons() {
    return (
      <>
        <Grid style={{ float: 'left' }}>
          <RACButton
            variant="outlined"
            color="primary"
            style={{
              padding: '12px 30px',
              borderRadius: '5px',
              marginTop: '25px',
            }}
            onClick={() => {
              handlePrevious()
            }}
          >
            {t("Back")}
          </RACButton>
        </Grid>

        <Grid style={{ float: 'right' }}>
          <RACButton
            variant="contained"
            color="primary"
            style={{
              padding: '12px 30px',
              borderRadius: '5px',
              marginTop: '25px',
            }}
            onClick={() => {
              ResidenceNextClick();
            }}
            disabled={!isNextEnabled} // Disable button if not all fields are valid
          >
            {t("Next")}
          </RACButton>
        </Grid>
      </>
    );
  }
};

export default ResidenceTab;